import Tippy from "@tippyjs/react";
import 'tippy.js/dist/tippy.css';
/**
 * Button wrapped in a Tippy tooltip. Can pass in variant prop to specify button style.
 * 
 * Same button as the regular button component. Needed its own component because Tippy cannot wrap around function components.
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const TooltipButton = ({ children, onClick, variant = "primary", className = "", disabled = false, tooltipLabel, tooltipDisabled = true }) => {
    const variantStyles = {
        primary: "bg-purple-700 hover:bg-purple-800 text-white py-2 px-4",
        secondary: "bg-black hover:bg-gray-900 text-white py-2 px-4",
        danger: "bg-red-600 hover:bg-red-700 text-white py-2 px-4",
        success: "bg-emerald-500 hover:bg-emerald-600 text-white py-2 px-4",
        caution: "bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-4",
        cancel: "bg-gray-500 hover:bg-gray-600 text-white py-2 px-4",
        noBackground: "text-gray-900 hover:text-gray-950 py-2 px-4",
        border: "text-purple-900 hover:text-purple-950 border-2 border-purple-800 px-3 py-1.5"
    };

    // Combine variant styles with any custom classes passed
    const styles = `${variantStyles[variant]} font-bold rounded flex items-center whitespace-nowrap ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`;

    return (
        <Tippy
            content={tooltipLabel}
            disabled={tooltipDisabled}
            placement="right"
            delay={[100, 0]}
        >
            <button onClick={onClick} className={styles} disabled={disabled}>
                {children}
            </button>
        </Tippy>
    );
};
